module.exports = __webpack_public_path__ + "media/assets/images/snow-ac4a778ca9bbd0b4f05486d2d15326aa.png";